module.exports = __webpack_public_path__ + "static/media/selfdirector.f4d029d1.jpg";